export default __webpack_public_path__ + "static/media/home.0f72a706.svg";